import { Event } from '../../communication/model/event.model';
export let events: Event[] = [
    {
        "id": "46549867",
        "name": "File Off Site",
        "documentName": null,
        "documentType": null,
        "date": new Date("2017-05-25T10:19:00"),
        "category": "Other",
        "party": "Unknown",
    },
    {
        "id": "44023616",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-10-31T11:16:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "44002604",
        "name": "Email - Invoice",
        "documentName": "120552EF-7802-49F2-8E05-45376ABD1CBD.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-10-28T09:44:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "43185172",
        "name": "Update Completed to Intermediary",
        "documentName": "A4C49825-A84B-452E-B051-ED232A789D61.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-08-22T10:26:00"),
        "category": "Email",
        "party": "Intermediary"
    },
    {
        "id": "40718713",
        "name": "Assignment Complete",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-05-04T11:12:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "40718696",
        "name": "Acceptance Agreement",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-05-04T11:11:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "40718684",
        "name": "Email - Claim Correspondence",
        "documentName": "ECA3BB24-713A-4BC2-8739-FA326555A7AC.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-05-04T11:11:00"),
        "category": "Email",
        "party": "Intermediary"
    },
    {
        "id": "40718671",
        "name": "Email - Claim Correspondence",
        "documentName": "E9CFB6EF-F5FF-4412-98A3-AE370C316BAD.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-05-04T11:10:00"),
        "category": "Email",
        "party": "Insured"
    },
    {
        "id": "40683145",
        "name": "Email - Invoice",
        "documentName": "0AB72D68-A58A-4E23-9CB8-C3A08D04B54C.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-04-28T10:44:00"),
        "category": "Email",
        "party": "Crawford Other Branch"
    },
    {
        "id": "40673684",
        "name": "Update Completed to Intermediary",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-04-27T12:25:00"),
        "category": "Email",
        "party": "Intermediary"
    },
    {
        "id": "40669389",
        "name": "Assignment Settlement",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-04-27T08:55:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "40661554",
        "name": "Final Report issued",
        "documentName": "Final (Long) for Property claim.DOC",
        "documentType": "DOC",
        "date": new Date("2016-04-27T08:54:47.443"),
        "category": null,
        "party": "Insurer"
    },
    {
        "id": "40667979",
        "name": "Update Completed to Intermediary",
        "documentName": "1542A222-D859-4D5E-8718-417FB41C3F70.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-04-26T17:22:00"),
        "category": "Email",
        "party": "Intermediary"
    },
    {
        "id": "40665186",
        "name": "Update Completed to InsureD",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-04-26T15:05:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "40661344",
        "name": "Letter Issued",
        "documentName": "Letter - headings only for Property claim1.DOC",
        "documentType": "DOC",
        "date": new Date("2016-04-26T15:02:17.77"),
        "category": null,
        "party": "Claimant"
    },
    {
        "id": "40610334",
        "name": "Update Completed to InsureR",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-04-19T14:11:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "40496378",
        "name": "Letter Issued",
        "documentName": "Letter - headings only for Property claim.DOC",
        "documentType": "DOC",
        "date": new Date("2016-04-04T12:42:45.147"),
        "category": null,
        "party": "Insured"
    },
    {
        "id": "40410482",
        "name": "Email - Claim Correspondence",
        "documentName": "AAB56A70-B3EB-4BB5-936D-19BD90C4D953.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-03-19T11:43:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "40398665",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-03-17T14:49:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "40063422",
        "name": "Email - Claim Correspondence",
        "documentName": "4BDFA59E-C813-4672-A021-72D3289ADE4C.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-02-01T12:20:00"),
        "category": "Email",
        "party": "Insured"
    },
    {
        "id": "40063381",
        "name": "Email - Claim Correspondence",
        "documentName": "808BC1A1-F9B0-48CC-9C0F-5E7F0F4611B0.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-02-01T12:18:00"),
        "category": "Email",
        "party": "Intermediary"
    },
    {
        "id": "40041070",
        "name": "Email - Invoice",
        "documentName": "1AD13A0D-6ED5-416B-BAFD-2C77FAC6B3DA.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-01-28T11:28:00"),
        "category": "Email",
        "party": "Crawford Other Branch"
    },
    {
        "id": "39984005",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2016-01-21T09:10:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "39967913",
        "name": "Letter Issued",
        "documentName": "Letter - headings only for Property claim11809767.DOC",
        "documentType": "DOC",
        "date": new Date("2016-01-19T14:52:18.113"),
        "category": null,
        "party": "Claimant"
    },
    {
        "id": "39969015",
        "name": "Email - Claim Correspondence",
        "documentName": "D147465D-9FB4-4E3E-83F9-887BEC1C813C.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-01-19T14:46:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "39968925",
        "name": "Email - Claim Correspondence",
        "documentName": "E782EA39-1A81-4F16-9AFC-7AE4D0535CDC.ZIP",
        "documentType": "ZIP",
        "date": new Date("2016-01-19T14:41:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "39552927",
        "name": "Letter Issued",
        "documentName": "Letter - headings only for Property claim11766702.DOC",
        "documentType": "DOC",
        "date": new Date("2015-11-17T13:33:27.267"),
        "category": null,
        "party": "Claimant"
    },
    {
        "id": "39526474",
        "name": "Letter Issued",
        "documentName": "Letter - headings only for Property claim11763983.DOC",
        "documentType": "DOC",
        "date": new Date("2015-11-12T13:39:59.82"),
        "category": null,
        "party": "Claimant"
    },
    {
        "id": "39529584",
        "name": "Update Completed to InsureR",
        "documentName": "734836ED-F3D2-45AB-896F-43E4156F6760.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-11-12T12:45:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "39529484",
        "name": "Email - Claim Correspondence",
        "documentName": "7F6F5BCC-7AC6-41E8-8D8F-3F991406D0F8.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-11-12T12:35:00"),
        "category": "Email",
        "party": "Crawford Own Branch"
    },
    {
        "id": "39468345",
        "name": "Email - Claim Correspondence",
        "documentName": "FC73DC39-0F3B-499E-84B5-A5DE9388833F.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-11-03T15:38:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "39466032",
        "name": "Email - Claim Correspondence",
        "documentName": "507A948A-51FA-4002-BEFA-FAFFD76B718A.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-11-03T13:22:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "39460216",
        "name": "Update Completed to InsureD",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-11-02T16:56:00"),
        "category": "Email",
        "party": "Insured"
    },
    {
        "id": "39447198",
        "name": "Letter Issued",
        "documentName": "Letter - headings only for Property claim1.DOC",
        "documentType": "DOC",
        "date": new Date("2015-10-30T13:14:02.4"),
        "category": null,
        "party": "Claimant"
    },
    {
        "id": "39258315",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-10-01T09:10:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "39233867",
        "name": "Update Completed to InsureR",
        "documentName": "2EE3FED0-1D0A-42C9-ADA9-4E6BA56B7072.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-09-28T11:29:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "39233876",
        "name": "Interim Report issued",
        "documentName": "Interim 1234996_11733087(1234996).DOC",
        "documentType": "DOC",
        "date": new Date("2015-09-28T11:29:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "39232779",
        "name": "Email - Invoice",
        "documentName": "2D28C712-61A6-44AA-B02B-ADFE9BD05813.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-09-28T10:18:00"),
        "category": "Email",
        "party": "Crawford Other Branch"
    },
    {
        "id": "38913399",
        "name": "Update Completed to InsureD",
        "documentName": "BB2D252A-86C3-47CE-A3D0-11761932E2B9.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-08-03T11:44:00"),
        "category": "Email",
        "party": "Insured"
    },
    {
        "id": "38883203",
        "name": "Update Completed to InsureR",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-28T14:35:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "38844915",
        "name": "Update Completed to InsureD",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-21T17:27:00"),
        "category": "Email",
        "party": "Insured"
    },
    {
        "id": "38844859",
        "name": "Update Completed to InsureD",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-21T17:19:00"),
        "category": "Email",
        "party": "Insured"
    },
    {
        "id": "38821003",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-17T10:17:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "38820964",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-17T10:14:00"),
        "category": "Email",
        "party": "Claimant"
    },
    {
        "id": "38806385",
        "name": "Preliminary Report issued",
        "documentName": "Prelim (Long) for Property claim11686483.DOC",
        "documentType": "DOC",
        "date": new Date("2015-07-17T09:57:04.057"),
        "category": null,
        "party": "Insurer"
    },
    {
        "id": "38820541",
        "name": "Update Completed to Intermediary",
        "documentName": "695EF241-9343-4736-9C98-E5F795A42D4B.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-07-17T09:49:00"),
        "category": "Email",
        "party": "Intermediary"
    },
    {
        "id": "38808632",
        "name": "GLLD Status - Not Large Loss",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-15T14:43:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "38806354",
        "name": "Initial Visit made",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-14T09:30:00"),
        "category": "Visit",
        "party": "Unknown"
    },
    {
        "id": "38785830",
        "name": "CMIT CFS Requested Screening",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-10T17:19:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "38785833",
        "name": "Email Sent",
        "documentName": "2D2FE0C5-8FA9-45D4-8E6E-0793775F0552.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-07-10T17:19:00"),
        "category": "Email",
        "party": "Crawford Other Branch"
    },
    {
        "id": "38769911",
        "name": "CMIT CFS Screening considered",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-08T17:19:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "38760325",
        "name": "Email - Claim Correspondence",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-07T15:43:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "38760305",
        "name": "Email - Claim Correspondence",
        "documentName": "FD9CAD60-0275-4BC1-A370-2AE7620B6EB0.ZIP",
        "documentType": "ZIP",
        "date": new Date("2015-07-07T15:42:00"),
        "category": "Email",
        "party": "Insurer"
    },
    {
        "id": "38760265",
        "name": "Incident Capture Complete",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-07T15:41:02.64"),
        "category": null,
        "party": "Unknown"
    },
    {
        "id": "38760264",
        "name": "GLLD Status - Undetermined",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-07T15:41:00"),
        "category": "Other",
        "party": "Unknown"
    },
    {
        "id": "38806334",
        "name": "Initial Contact made",
        "documentName": null,
        "documentType": null,
        "date": new Date("2015-07-07T11:53:00"),
        "category": "Telephone",
        "party": "Insured"
    }
]


// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/report/data/event-list.source.ts